/**
 * DataBest — PerfPieChart
 * Simple donut/pie for Caregiver Performance (Total Records, % On-Time).
 */
import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from "recharts";

const PerfPieChart = ({ title, data = [], testId }) => {
    const total = data.reduce((s, d) => s + (d.value || 0), 0);
    const hasData = total > 0;
    const chartData = hasData ? data : [{ name: "No data", value: 1, color: "#e2e8f0" }];

    return (
        <div
            className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm"
            data-testid={testId}
        >
            <p className="mb-2 text-center text-sm font-bold text-slate-700">{title}</p>
            <div className="h-56 w-full min-w-[10px] sm:h-64">
                <ResponsiveContainer width="100%" height="100%" minWidth={10} minHeight={10}>
                    <PieChart>
                        <Pie
                            data={chartData}
                            dataKey="value"
                            nameKey="name"
                            cx="50%"
                            cy="50%"
                            innerRadius="45%"
                            outerRadius="75%"
                            paddingAngle={1}
                            isAnimationActive={false}
                            label={
                                hasData
                                    ? ({ percent }) => `${(percent * 100).toFixed(2)}%`
                                    : false
                            }
                            labelLine={false}
                        >
                            {chartData.map((d, i) => (
                                <Cell key={i} fill={d.color} />
                            ))}
                        </Pie>
                        {hasData && (
                            <Tooltip
                                contentStyle={{
                                    fontSize: 11,
                                    border: "1px solid #e2e8f0",
                                    borderRadius: 6,
                                }}
                                formatter={(v, n) => [`${v}`, n]}
                            />
                        )}
                        <Legend
                            iconType="circle"
                            wrapperStyle={{ fontSize: 11, paddingTop: 4 }}
                        />
                    </PieChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
};

export default PerfPieChart;
